function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

class SubscriptionPicker extends HTMLElement {
  connectedCallback() {
    this.radioOneTimeElement = this.querySelector('[data-radio-one-time]');
    this.radioSubscribeElement = this.querySelector('[data-radio-subscribe]');
    this.sellingPlanInputElement = this.querySelector('[data-selling-plan-input]');
    this.nestedProductInputElements = this.querySelectorAll('[data-nested-product-input]');
    this.oneTimeQuantityInputElement = this.querySelector('[data-quantity-input="one_time"]');
    this.subscribeQuantityInputElement = this.querySelector('[data-quantity-input="subscribe"]');
    this.oneTimeFreeLabelElement = this.querySelector('[data-one-time-free-label]');
    this.oneTimePriceLabelElement = this.querySelector('[data-one-time-price-label]');

    this.radioOneTimeElement.addEventListener('change', this.handleRadioChange.bind(this));
    this.radioSubscribeElement.addEventListener('change', this.handleRadioChange.bind(this));

    this.oneTimeQuantityInputElement?.addEventListener('change', this.handleQuantityChange.bind(this));
    this.subscribeQuantityInputElement?.addEventListener('change', this.handleQuantityChange.bind(this));
  }

  handleRadioChange() {
    const isSubscription = this.radioSubscribeElement.checked;

    this.sellingPlanInputElement?.toggleAttribute('disabled', !isSubscription);

    if (this.oneTimeQuantityInputElement) this.oneTimeQuantityInputElement.disabled = isSubscription;
    if (this.subscribeQuantityInputElement) this.subscribeQuantityInputElement.disabled = !isSubscription;

    this.nestedProductInputElements.forEach((inputElement) => {
      inputElement.disabled = !isSubscription;
    });

    this.updatePrice(isSubscription);

    document.dispatchEvent(
      new CustomEvent('subscription-picker:change', {
        detail: {
          sectionId: this.dataset.sectionId,
          isSubscription,
        },
      })
    );
  }

  handleQuantityChange(event) {
    const isSubscribeInput = event.target.dataset.quantityInput === 'subscribe';
    const radioToSelect = isSubscribeInput ? this.radioSubscribeElement : this.radioOneTimeElement;

    if (!radioToSelect.checked) {
      radioToSelect.checked = true;
      this.handleRadioChange();
      return;
    }

    this.updatePrice(this.radioSubscribeElement.checked);
  }

  updatePrice(isSubscription) {
    const formElement = document.getElementById(this.dataset.formId);
    const priceElement = formElement?.querySelector('[data-price]');
    if (!priceElement) return;

    const priceCents = isSubscription
      ? parseInt(this.dataset.subscriptionPriceCents, 10)
      : parseInt(this.dataset.oneTimePriceCents, 10);

    const quantityInput = isSubscription
      ? this.subscribeQuantityInputElement
      : this.oneTimeQuantityInputElement;

    const quantity = parseInt(quantityInput?.value, 10) || 1;
    const totalCents = priceCents * quantity;
    const formattedPrice = formatMoney(totalCents, this.dataset.moneyFormat);

    const priceMoneyLabelElement = priceElement.querySelector('[data-price-money-label]');
    if (priceMoneyLabelElement) {
      priceMoneyLabelElement.textContent = formattedPrice;
    } else {
      priceElement.textContent = formattedPrice;
    }

    this.updateOneTimeFreeDisplay(isSubscription, quantity, priceElement);
  }

  updateOneTimeFreeDisplay(isSubscription, quantity, priceElement) {
    const showFree = !isSubscription && this.dataset.firstFree === 'true' && quantity === 1;

    this.oneTimeFreeLabelElement?.toggleAttribute('hidden', !showFree);
    this.oneTimePriceLabelElement?.toggleAttribute('hidden', showFree);

    priceElement?.querySelector('[data-price-free-label]')?.toggleAttribute('hidden', !showFree);
    priceElement?.querySelector('[data-price-money-label]')?.toggleAttribute('hidden', showFree);
  }
}

customElements.define('subscription-picker', SubscriptionPicker);